import { render, staticRenderFns } from "./BaseInputText.vue?vue&type=template&id=5a180d36&scoped=true&"
import script from "./BaseInputText.vue?vue&type=script&lang=js&"
export * from "./BaseInputText.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputText.vue?vue&type=style&index=0&id=5a180d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a180d36",
  null
  
)

export default component.exports